const isExpression = value => value.charAt(0) === '=';

export default isExpression;
